/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"

const EditQuestion = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 21 20">
    <svg
      width="21px"
      height="20px"
      viewBox="0 0 21 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="1.-Add-new-survey" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Add-new-Custom-Survey---Step-2,-Pulse-surveys,-All-steps,-Desktop"
          transform="translate(-1138.000000, -999.000000)"
          fill="#D0D0D0">
          <g id="Group-4" transform="translate(145.000000, 470.000000)">
            <g id="Group-119" transform="translate(26.000000, 504.000000)">
              <g id="Page-1-Copy-4" transform="translate(967.000000, 25.000000)">
                <path
                  d="M19.0940894,5.50979414 L17.9061849,6.61971686 L13.701935,2.70742304 L14.8219037,1.64895369 C15.332392,1.17117239 16.1709128,1.16198429 16.6911062,1.63057749 L19.0785612,3.78426859 C19.3308938,4.01213352 19.4725883,4.31901613 19.4745293,4.64427494 C19.4784114,4.97137137 19.34254,5.27825397 19.0940894,5.50979414 Z M6.68320562,17.0647512 L4.97316674,15.4990986 L15.2799845,5.97838734 L16.9376158,7.5238261 L6.68320562,17.0647512 Z M1.49097634,17.9523218 L2.04416712,14.6078527 L5.20026612,17.496592 L1.49097634,17.9523218 Z M2.54495036,13.2755779 L12.7411299,3.61704514 L14.3094743,5.07795335 L3.99683354,14.6041775 L2.54495036,13.2755779 Z M20.016074,2.85259505 L17.628619,0.698903951 C16.5785271,-0.247470553 14.8898394,-0.230931969 13.8630397,0.737493979 L12.7314248,1.80515143 L1.0950082,12.8271986 C1.00378025,12.9319429 0.928080456,13.0458754 0.904788213,13.1836969 L0.00803683811,18.6028395 C-0.0249605068,18.8013025 0.0449162236,19.0052783 0.194374786,19.1504503 C0.322482125,19.2754085 0.497173951,19.3452381 0.679629859,19.3452381 C0.708745163,19.3452381 0.737860468,19.3434005 0.766975772,19.3397252 L6.77443357,18.6010018 C6.92389214,18.5826256 7.04811743,18.5091208 7.15293253,18.4117269 L18.385617,7.97955595 L18.5971882,7.78293057 L18.8766951,7.5238261 L20.0490713,6.42676672 C20.5615007,5.9471478 20.8390666,5.31133114 20.8332435,4.63324922 C20.8293615,3.95700491 20.5382085,3.32486349 20.016074,2.85259505 Z"
                  id="Fill-1"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </BaseSvgIcon>
)

export default EditQuestion
